import image1 from '../../assets/project1.jpg';
import image2 from '../../assets/project2.png';
import image3 from '../../assets/project3.png';

const project1 = [
    {
        title: 'fastX Delivery App',
        description: 'fastX Delivery App is a cutting-edge food delivery platform designed to revolutionize the way meals are ordered and delivered. Leveraging advanced technology, it offers fast, reliable, and efficient delivery services tailored to meet the needs of modern consumers. Whether you\'re ordering from local restaurants or receiving groceries, fastX ensures a seamless and secure process from start to finish.',
        liveDemo: 'https://fastx-delivery-app.vercel.app/',
        codeLink: 'https://github.com/johnwalle/fastx-delivery-app',
        image: image1
    }
];


const project2 = [
    {
        title: 'Yenewub PharmacyStock',
        description: 'Yenewub PharmacyStock is a comprehensive inventory management system tailored specifically for pharmacies. This application streamlines the process of tracking and managing pharmaceutical stock, ensuring that pharmacies can maintain optimal inventory levels, reduce waste, and enhance overall efficiency. With features such as real-time stock updates, automated reorder alerts, and detailed reporting, Yenewub PharmacyStock empowers pharmacy staff to focus on providing excellent patient care while keeping their inventory organized and up-to-date.',
        liveDemo: 'https://pharmastock-pro.vercel.app',
        codeLink: 'https://github.com/johnwalle/pharmastock-pro',
        image: image2
    }
];



const project3 = [
    {
        title: 'Ethiopian Artisan Marketplace',
        description: 'The Ethiopian Artisan Marketplace is an online platform dedicated to showcasing and selling handmade crafts and products created by skilled artisans from Ethiopia. This marketplace aims to promote traditional Ethiopian craftsmanship while providing artisans with a broader audience to sell their unique creations. From intricate jewelry and textiles to pottery and woodwork, the platform offers a diverse range of authentic Ethiopian products. By connecting artisans directly with customers, the Ethiopian Artisan Marketplace fosters economic growth within local communities and preserves the rich cultural heritage of Ethiopia.',
        liveDemo: 'https://ethiopian-crafts-e-commerce.vercel.app',
        codeLink: 'https://github.com/johnwalle/Ethiopian-Crafts-eCommerce',
        image: image3
    }
];

// const project4 = [
//     {
//         title: 'Real-Time Chat App',
//         description: 'Stay connected with your friends through our easy-to-use real-time chat. Send messages back and forth and see when each other is typing or has read your messages. The chat updates instantly so you can have natural, flowing conversations',
//         liveDemo: 'https://real-time-chat-app-vert.vercel.app',
//         codeLink: 'https://github.com/johnwalle/Real-Time-ChatApp',
//         image: 'https://res.cloudinary.com/dso7gnmps/image/upload/v1723375302/Screenshot_2024-08-11_142021_tmof5z.png'
//     }
// ];

export { project1, project2, project3};